// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zA0_","toggleWrap":"styles_toggleWrap__9ZsAN","content":"styles_content__M5WPd","selectAreaCode":"styles_selectAreaCode__14ppS"};